import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0fc4ee21&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc4ee21')) {
      api.createRecord('0fc4ee21', component.options)
    } else {
      api.reload('0fc4ee21', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=0fc4ee21&", function () {
      api.rerender('0fc4ee21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ispforum/report/Index.vue"
export default component.exports